<p>sensor-setting works!</p>
